import { AxiosError } from 'axios';

interface CollectionKimeraError {
    errorKey: string;
}

const COLLECTION_KIMERA_ERRORS = [
    'too_many_collections',
    'too_many_items',
    'name_exists',
    'illegal_name_length',
] as const;
export type ErrorKey = (typeof COLLECTION_KIMERA_ERRORS)[number];
export function isErrorKey(key: any): key is ErrorKey {
    return COLLECTION_KIMERA_ERRORS.includes(key);
}

export function isCollectionKimeraError(error: any): error is AxiosError<CollectionKimeraError> {
    return error.isAxiosError && error.response?.data && isErrorKey(error.response.data.errorKey);
}
